/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_PrintInputs */

const en_val_print = /** @type {(inputs: Val_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Print`)
};

const es_val_print = /** @type {(inputs: Val_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impresión / Grabado`)
};

const fr_val_print = /** @type {(inputs: Val_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impression`)
};

const de_val_print = /** @type {(inputs: Val_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Druck`)
};

const ja_val_print = /** @type {(inputs: Val_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリント・版画`)
};

const zh_val_print = /** @type {(inputs: Val_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`版画`)
};

const ar_val_print = /** @type {(inputs: Val_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طباعة`)
};

const id_val_print = /** @type {(inputs: Val_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cetak`)
};

const it_val_print = /** @type {(inputs: Val_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stampa / Litografia`)
};

const ru_val_print = /** @type {(inputs: Val_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Репродукция / Гравюра`)
};

const pt_val_print = /** @type {(inputs: Val_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impressão`)
};

const ko_val_print = /** @type {(inputs: Val_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판화/프린트`)
};

/**
* | output |
* | --- |
* | "Print" |
*
* @param {Val_PrintInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_print = /** @type {((inputs?: Val_PrintInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_PrintInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_print(inputs)
	if (locale === "es") return es_val_print(inputs)
	if (locale === "fr") return fr_val_print(inputs)
	if (locale === "de") return de_val_print(inputs)
	if (locale === "ja") return ja_val_print(inputs)
	if (locale === "zh") return zh_val_print(inputs)
	if (locale === "ar") return ar_val_print(inputs)
	if (locale === "id") return id_val_print(inputs)
	if (locale === "it") return it_val_print(inputs)
	if (locale === "ru") return ru_val_print(inputs)
	if (locale === "pt") return pt_val_print(inputs)
	return ko_val_print(inputs)
});